export { default as Chat } from './Chat';
export { default as Internet } from './Internet';
export { default as Gps } from './Gps';
export { default as Phone } from './Phone';
